export default __webpack_public_path__ + "static/media/Pokemon_Theme_Song.71409d78.mp3";